import React, { useEffect, useRef, useState } from "react";
import { PageLayout } from "../../../layouts/PageLayout";
import { Col, Row } from "react-bootstrap";
import { CardLayout } from "../../../components/cards";
import { Breadcrumb } from "../../../components";
import { Anchor, Box, Heading, Image, Item, List, Text } from "../../../components/elements";
import { Table, Tbody, Td, Th, Thead, Tr } from "../../../components/elements/Table";
import { Post } from "../../../services/services";
import { useParams } from "react-router-dom";
import { useReactToPrint } from "react-to-print";
import { DownloadAndPrint } from "../../../components/DownloadAndPrint";

interface AccountInvoiceData {
  date?: string;
  project_name?: string;
  remarks?: string;
  type?: string;
  amount?: string | number;
  user_from_name?: string;
  created_by?: string;
  user_to_name?: string;
  [key: string]: any;
}

export const AccountInvoice = () => {
  const [invoiceData, setInvoiceData] = useState<Partial<AccountInvoiceData>>({});

  const { id } = useParams();
  const printRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = () => {
    Post(
      "/account/singleTransaction",
      {
        id: id,
      },
      (status, response) => {
        setInvoiceData(response.data);
      },
    );
  };

  // For creating table in invoice
  const keysToInclude = ["date", "project_name", "remarks", "type", "amount"];

  const tableHeaders = [];

  const tableData = [];

  // iterating over each key and adding data to it
  keysToInclude.forEach((key) => {
    tableHeaders.push(key);

    tableData.push(invoiceData[key]);
  });

  const handlePrint = useReactToPrint({
    contentRef: printRef,
  });

  return (
    <PageLayout>
      <Row>
        <Col xl={12}>
          <CardLayout>
            <Breadcrumb title={"Invoice Details"} />
          </CardLayout>
        </Col>
        <Col xl={12}>
          <div ref={printRef}>
            <CardLayout className="p-md-5">
              <Box className="mc-invoice-head">
                <Image src={"images/CoWalletLogo.webp"} alt={"logo"} />
                <Heading as="h2">{"transaction report"}</Heading>
              </Box>
              <Box className="mc-invoice-group">
                <Box className="mc-invoice-recieved">
                  <Heading as="h6">Payment From</Heading>
                  <Text>{invoiceData.user_from_name}</Text>
                  <Text>{invoiceData.created_by}</Text>
                </Box>
                <Box className="mc-invoice-shipment">
                  <Heading as="h6">Payment To</Heading>
                  <Text>{invoiceData.user_to_name}</Text>
                </Box>
              </Box>
              <Box className="mc-table-responsive">
                <Table className="mc-table">
                  <Thead className="mc-table-head">
                    <Tr>
                      {tableHeaders?.map((item, index) => (
                        <Th key={index}>{item}</Th>
                      ))}
                    </Tr>
                  </Thead>
                  <Tbody className="mc-table-body">
                    <Tr>
                      {tableData?.map((item, index) => (
                        <Td>{item}</Td>
                      ))}
                    </Tr>
                  </Tbody>
                </Table>
              </Box>

              <Box className="mc-invoice-list-group">
                <List className="mc-invoice-list">
                  <Item>
                    <Text as="span" className="title">
                      Total
                    </Text>
                    <Text as="span" className="clone">
                      :
                    </Text>
                    <Text as="span" className={"digit total"}>
                      ₹{tableData[4]}
                    </Text>
                  </Item>
                </List>
              </Box>
            </CardLayout>
          </div>
          <DownloadAndPrint handlePrint={handlePrint} printRef={printRef} fileName={"AccountInvoice.pdf"} />
        </Col>
      </Row>
    </PageLayout>
  );
};
